import { lazy } from 'react'

export const ReasonsVariant2 = lazy(() => import('./ReasonsVariant2'))
export const ReasonsVariant3 = lazy(() => import('./ReasonsVariant3'))
